import React from 'react';
import classnames from 'classnames/bind';
import style from './index.module.scss';
import WorkShopTypeDropdown from '../WorkshopTypeDropdown';
import OpeningHoursDropdown from '../OpeningHoursDropdown';
import DistanceDropdown from '../DistanceDropdown';
import LocationSearch from '../LocationSearch';
import { ICountry, IState, Replacement } from '../../../../interface';
import localesReplacement from '../../../../utils/localesReplacement';
import { connect } from 'react-redux';
import _ from 'lodash';
import { DISABLED_OPENING_HOUR_COUNTRIES } from '../../../../constants';

const cx = classnames.bind(style);

interface IProps {
  overlay: boolean;
  replacements: Replacement;
  setOverlay: (value: boolean) => void;
  country: ICountry;
}

//Filter for workshop type & workshop rating & opening hours & promotions
function FilterCategory(props: IProps) {
  const { overlay, replacements, setOverlay, country } = props;
  return (
    <>
      <div className={cx('filter-category', { overlay: overlay })}>
        <div className={cx('heading')}>
          <span
            className='link back-link'
            role='link'
            onClick={() => setOverlay(false)}
          ></span>
          <h5>{localesReplacement(replacements, 'FIlters')}</h5>
        </div>
        <div className={cx('inner')}>
          <div className={cx('col')}>
            <LocationSearch />
          </div>
          <div className={cx('col')}>
            {/* filter for workshop type */}
            <WorkShopTypeDropdown />
          </div>
          {!!country.id && (
            <>
              {!DISABLED_OPENING_HOUR_COUNTRIES.includes(country.isoCode) && (
                <div className={cx('col')}>
                  {/* filter for opening hours */}
                  <OpeningHoursDropdown />
                </div>
              )}
            </>
          )}
          {!!country.id && (
            <>
              {
                <div className={cx('col')}>
                  {/* filter for opening hours */}
                  <DistanceDropdown />
                </div>
              }
            </>
          )}
        </div>
      </div>
      <div
        className={cx('mask', { overlay: overlay })}
        onClick={() => setOverlay(false)}
      ></div>
    </>
  );
}

const mapStateToProps = (state: IState) => ({
  replacements: state.replacements,
  country: state.country,
});

export default connect(mapStateToProps)(FilterCategory);
